import { Box, Stack, Typography, Grid } from '@mui/material'

import { useT } from '@clara/locale'
import { Button } from '@clara/ui'
import { DepositIcon } from '@clara/icons'

import MissingBankInfo from 'assets/images/missing-bank-info.svg'
import { Header, HeaderElement, useSidePanelContext } from '@clara/layout-next'
import { useGlobalStateContext } from '@/store/global/use-global-state'
import { getBankInfoSidePanel } from './sidepanel'
import { useEvents } from '@/hooks/use-analytics'

export const BankInfoBlankState = () => {
  const { t } = useT('reimbursements')
  const sidePanel = useSidePanelContext()
  const { getBankInfo, bankInfo, userInfoResponse } = useGlobalStateContext()
  const events = useEvents()

  return (
    <>
      <Header>
        <HeaderElement variant="title">{t('main.title')}</HeaderElement>
      </Header>
      <Grid
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          flexDirection: 'column',
          mt: theme.spacing(9),
        })}
        gap={3}
      >
        <img src={MissingBankInfo} alt="start using reimbursements" />
        <Stack
          sx={(theme) => ({
            maxWidth: theme.spacing(66),
            textAlign: 'center',
          })}
          gap={1}
        >
          <Typography
            variant="h3"
            sx={{
              color: (theme) => theme.palette.v3.content.high_emphasis,
              fontWeight: 600,
            }}
          >
            {t('bankinfo.emptystate.title')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: (theme) => theme.palette.v3.content.medium_emphasis,
            }}
          >
            {t('bankinfo.emptystate.description')}
          </Typography>
        </Stack>
        <Box>
          <Button
            sx={{ px: 5 }}
            leftIcon={<DepositIcon />}
            onClick={() => {
              events.linkingAccount()

              sidePanel.onOpen(
                getBankInfoSidePanel({
                  getBankInfo,
                  bankInfo,
                  userInfoResponse,
                }),
              )
            }}
          >
            {t('bankinfo.emptystate.button')}
          </Button>
        </Box>
      </Grid>
    </>
  )
}
